import type { StateCreator } from 'zustand';

export interface ToolbarSlice {
  setToolbarTitle: (toolbarTitle: string) => void;
  toolbarTitle: string;
}

export const toolbarSlice: StateCreator<ToolbarSlice, [], [], ToolbarSlice> = (
  set,
) => ({
  toolbarTitle: '',
  setToolbarTitle: (toolbarTitle: string) => set({ toolbarTitle }),
});
